export default __webpack_public_path__ + "static/media/roompage-add.87f3f5f8.svg";